export enum DateTimeDisplay {
    DateTime = 0,
    DateOnly = 1,
    TimeOnly = 2,
}
